<template>
  <norma-widget
    v-if="exibirNorma"
    :api-url="apiUrl"
    :environment="environment"
    embedded
  ></norma-widget>
</template>

<script>
import LegislacaoMunicipalApi from "../services/LegislacaoMunicipalApi";

// A Norma consulta apenas a legislação do Estado de Goiás (ente_federativo.id = 1)
const ENTE_FEDERATIVO_GOIAS_ID = 1;

export default {
  name: "AssistenteNorma",
  data() {
    return {
      apiUrl: process.env.VUE_APP_NORMA_API_URL,
      environment: process.env.VUE_APP_NORMA_ENVIRONMENT,
      routerPronto: false,
      enteFederativoId: null,
      requisicaoAtual: 0,
    };
  },
  computed: {
    exibirNorma() {
      return this.routerPronto && this.enteFederativoId === ENTE_FEDERATIVO_GOIAS_ID;
    },
  },
  watch: {
    $route() {
      this.definirEnteFederativo();
    },
    exibirNorma(exibir) {
      if (exibir) {
        this.carregarBundle();
      }
    },
  },
  created() {
    this.legislacaoApi = new LegislacaoMunicipalApi();
    // Antes da navegação inicial, $route ainda não reflete a URL real
    this.$router.onReady(() => {
      this.routerPronto = true;
      this.definirEnteFederativo();
    });
  },
  methods: {
    async definirEnteFederativo() {
      const requisicao = ++this.requisicaoAtual;
      const { params, meta } = this.$route;
      this.enteFederativoId = null;

      // Rotas sem slug e sem marcação municipal são páginas do Estado de Goiás
      if (!params.slug) {
        if (!(meta && meta.isMunicipalLegislation)) {
          this.enteFederativoId = ENTE_FEDERATIVO_GOIAS_ID;
        }
        return;
      }

      try {
        const entesFederativos = await this.legislacaoApi.getEntesFederativos();
        const enteFederativo = (entesFederativos || []).find(ente => ente.slug === params.slug);
        // Ignora respostas de rotas que já foram deixadas
        if (requisicao === this.requisicaoAtual && enteFederativo) {
          this.enteFederativoId = enteFederativo.id;
        }
      } catch (error) {
        console.error("Erro ao identificar o ente federativo para a Norma:", error);
      }
    },
    carregarBundle() {
      if (document.getElementById("norma-bundle")) {
        return;
      }
      const script = document.createElement("script");
      script.id = "norma-bundle";
      script.type = "module";
      script.src = process.env.VUE_APP_NORMA_BUNDLE_URL;
      document.body.appendChild(script);
    },
  },
};
</script>
